import { JsonConverter, JsonCustomConvert } from "json2typescript";

@JsonConverter
export class FirewallStatusConverter implements JsonCustomConvert<FirewallStatus>{
	serialize() { }
	deserialize(data: any): FirewallStatus {
		switch (data) {
            case 0:
                return FirewallStatus.CLOSED;
            case 1:
                return FirewallStatus.LISTEN;
            case 2:
                return FirewallStatus.SYN_SENT;
            case 3:
                return FirewallStatus.SYN_RECEIVED;
            case 4:
                return FirewallStatus.ESTABLISHED;
            case 5:
                return FirewallStatus.CLOSE_WAIT;
            case 6:
                return FirewallStatus.FIN_WAIT_1;
            case 7:
                return FirewallStatus.CLOSING;
            case 8:
                return FirewallStatus.LAST_ACK;
            case 9:
                return FirewallStatus.FIN_WAIT_2;
            case 10:
                return FirewallStatus.TIME_WAIT;
            default:
                return FirewallStatus.UNDEFINED;
        }
	}
}


export enum FirewallStatus {
	CLOSED,
    LISTEN,
    SYN_SENT,
    SYN_RECEIVED,
    ESTABLISHED,
    CLOSE_WAIT,
    FIN_WAIT_1,
    CLOSING,
    LAST_ACK,
    FIN_WAIT_2,
    TIME_WAIT,
	UNDEFINED = -1
}
